(function () {
  'use strict';

  angular.module('app').component('clientTypeDetail', clientTypeDetail());

  function clientTypeDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: ClientTypeDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/client-types/client-type-detail/client-type-detail.component.html',
    };
  }

  ClientTypeDetailComponent.$inject = ['UtilService', 'ClientTypeService'];

  function ClientTypeDetailComponent(UtilService, ClientTypeService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var fieldsDefinition = ['name', 'description', 'is_business', 'commissionable'];

    // Methods
    //vm.openTranslations = openTranslations;
    vm.editClientType = editClientType;
    vm.cancelEdit = cancelEdit;
    vm.saveClientType = saveClientType;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          is_business: false,
          commissionable: false,
        };
      }
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        editClientType();
      }

      vm.originalItem = angular.copy(item); // store server data
    }

    function editClientType() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    function cancelEdit() {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    // Create/Update
    function saveClientType(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        ClientTypeService.saveClientType(vm.item, vm.defaultLanguage).then(function (data) {
          var status = data.status;
          var response = data.response;

          if (status) {
            // Success
            setItemOptions(response);
            vm.onSavedItem({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        });
      } else {
        cancel();
      }
    }

    function cancel() {
      /*if (vm.editMode){
                vm.cancelEdit();
                return;
            }*/

      vm.onCanceledItem();
    }
  }
})();
